import React from 'react';
import { useEffect, useState, useId } from 'react';
import { callApiWithToken } from '../fetch';
import { ButtonTable, LoadingOverlay } from '../components';

export const Events = ({eventSelected, token}) => {

    console.log(`Events constructor with token: ${token}`);
    const [events, setEvents] = useState(null);
    const [error, setError] = useState(null);
    const id = useId();

    const FetchEvents = (abortController) => {
        // console.log(`Events FetchEvents id: ${id}`);
        callApiWithToken(token, 'events', abortController).then((response) => {
            console.log(`Events ${JSON.stringify(response)}`);
            const newEvents = response.data.map(element => {
                let date = new Date(element.date.value)
                return {
                    displayDate: date.toLocaleDateString(),
                    ...element
                }
            });
            // console.log(`Setting events on ${id} with ${JSON.stringify(newEvents)}`);
            setEvents(newEvents);
        })
        .catch((error) => {
            const message = (typeof error.message === 'undefined') ? error : error.message;
            // console.log('Error fetching events: ', message);
            if (!message.startsWith('Abort: Events') && !message.startsWith('Unauthorized')) {
                setError(message);
                setEvents([]);
            }
        });
    };

    const EventSelected = (event) => {
        eventSelected(event.original);
    }

    const columns = React.useMemo(
        () => [
            {
                Header: 'Select An Event',
                columns: [
                {
                    Header: 'Title',
                    accessor: 'label',
                },
                {
                    Header: 'Date',
                    accessor: 'displayDate',
                },
                ],
            },
        ],
        []
    )

    useEffect(() => {
        const start = Date.now();
        const abortController = new AbortController();
        // console.log(`Events useEffect token: ${token} id: ${id} / ${start}`);
        FetchEvents(abortController);
        return () => {
            console.log(`Events component unmounted or effect re-run ${id} / ${start}`);
            abortController.abort(`Abort: Events component unmounted ${id} / ${start}`);
        }
    }, [token]);

    return (
        <LoadingOverlay
            active={!events}
            text='Loading Events...'
        >
            {error && <p className='fs-3'>Error fetching events: {error}</p>}
            {(!error && events && events.length === 0) &&
                <p className='fs-3'>No events currently open for registration. Please 
                    check&nbsp;<a href={process.env.REACT_APP_CALENDAR_URL}>the {process.env.REACT_APP_CALENDAR_NAME}</a>&nbsp;for
                    information about upcoming events.
                </p>
            }
            {(!error && events && events.length > 0) &&
                <div className='events-table'>
                    <ButtonTable columns={columns} data={events} rowSelected={EventSelected} />
                </div>
            }
        </LoadingOverlay>
    )
}

export default Events;